import type { Routes } from '@angular/router';

import { browserBackGuard } from './core/guards/browser-back.guard';
import { entryGuard } from './core/guards/entry.guard';
import { operatorLoginGuard } from './core/guards/operator-login.guard';

export const routes: Routes = [
  {
    // Ingresso del portale: non chiede credenziali, sceglie la destinazione. Anonimo -> onboarding,
    // sessione BFF gia' valida -> lista sessioni. La guardia restituisce sempre un UrlTree, quindi
    // questo ramo non rende mai nulla.
    path: '',
    pathMatch: 'full',
    canActivate: [entryGuard],
    children: [],
  },
  {
    // L'indirizzo del QR dello sportello nella forma a percorso: la stessa guardia dell'ingresso, che lo
    // riporta alla scelta della lingua col flow come parametro di query. Non rende mai nulla.
    path: 'flow/:flowId',
    canActivate: [entryGuard],
    children: [],
  },
  {
    // La porta della postazione. Esiste perche' un tenant puo' spegnere l'accesso del cittadino, e con
    // quei comandi spariti dall'intestazione l'operatore non avrebbe piu' un modo di arrivare al login.
    // La guardia non rende mai niente: porta il browser al BFF.
    path: 'operator-login',
    canActivate: [operatorLoginGuard],
    children: [],
  },
  {
    // Dove il BFF riporta un accesso che non si e' chiuso. Anonima come l'onboarding, e per una ragione
    // in piu': ci arriva chi una sessione non ce l'ha, e una guardia autenticata lo rimbalzerebbe al
    // login, cioe' esattamente dove ha appena fallito.
    path: 'sign-in-failed',
    loadComponent: () => import('./features/shell/ui').then((m) => m.PublicShellPage),
    children: [
      {
        path: '',
        canDeactivate: [browserBackGuard],
        loadComponent: () =>
          import('./features/auth/pages/sign-in-failed/sign-in-failed.page').then(
            (m) => m.SignInFailedPage,
          ),
      },
    ],
  },
  {
    // Le informative a un indirizzo proprio, da collegare dove la chat non c'e': il QR, le email, il sito
    // dell'ente, l'avviso sui cookie. Anonime come l'onboarding e nella stessa cornice: le legge anche chi
    // una sessione non ce l'ha ancora.
    path: 'privacy',
    loadComponent: () => import('./features/shell/ui').then((m) => m.PublicShellPage),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/onboarding/ui').then((m) => m.PrivacyPolicyPage),
      },
    ],
  },
  {
    path: 'cookie',
    loadComponent: () => import('./features/shell/ui').then((m) => m.PublicShellPage),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/onboarding/ui').then((m) => m.CookiePolicyPage),
      },
    ],
  },
  {
    // Flusso del Cittadino, anonimo: montato fuori dalla shell autenticata, prima del path '' della
    // shell, cosi' non passa mai dall'authGuard. La cornice pubblica porta accesso e registrazione.
    path: 'onboarding',
    loadComponent: () => import('./features/shell/ui').then((m) => m.PublicShellPage),
    loadChildren: () => import('./features/onboarding/ui').then((m) => m.ONBOARDING_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('./features/shell/ui').then((m) => m.SHELL_ROUTES),
  },
  {
    // Un indirizzo che non esiste lasciava lo schermo vuoto: il router non trovava la rotta e non rendeva
    // niente. Chi ci arriva trova l'invito a inquadrare il QR dello sportello, che e' la porta del portale.
    path: '**',
    redirectTo: 'onboarding/scan-qr',
  },
];
